import * as yup from "yup";

export const validationAddSchema = yup.object({
  name: yup.string().min(2).required("Name is required"),
});

export const editWorkflowSchema = yup.object().shape({
  name: yup.string().required("Rule Name is required"),
  description: yup.string().required("Module is required"),
  isActive: yup.string().required("Status is required"),
});